/* eslint-disable class-methods-use-this */
import React from 'react';
import OrgChartViz from '../../utils/d3.treeboxes';
import { withTranslation } from 'react-i18next';
export default class ViewCascadeVisualizationComp extends React.PureComponent {
  constructor(props) {
    super(props);
    this.containerRef = React.createRef();
  }

  componentDidMount() {
    const data = this.props.data || {};
    // Use full viewport width instead of constrained parent width
    let divWidth = window.innerWidth;

    // Use requestAnimationFrame to ensure container is sized by CSS flexbox
    requestAnimationFrame(() => {
      const container = this.containerRef.current;
      let containerHeight = 500; // Fallback

      // Get actual container height - flexbox should have sized it by now
      if (container) {
        container.offsetHeight; // Force reflow
        const measuredHeight = container.offsetHeight || container.clientHeight;
        if (measuredHeight && measuredHeight > 100) {
          containerHeight = measuredHeight;
        } else {
          // Fallback calculation if measurement fails
          const headerHeight = $('.alignmentTreeHeader').outerHeight() || 60;
          const backlinkHeight = $('.backlink').outerHeight() || 40;
          containerHeight = window.innerHeight - headerHeight - backlinkHeight - 100;
        }
      }

      // Tooltip test w/dummy long text fields
      // const loremIpsem = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec a diam lectus. Sed \
      //   sit amet ipsum mauris. Maecenas congue ligula ac quam viverra nec consectetur ante hendrerit.';
      // [data, [...data.children]].forEach(itm => {
      //   if (itm.name) itm.name += ' - ' + loremIpsem;
      //   if (itm.ownerName) itm.ownerName += ' is the owner name';
      //   if (itm.teamName) itm.teamName += ' is the team name';
      //   if (itm.sourceText) itm.sourceText += ' is the very long source text';
      // });

      this.setVizStyles(true);
      OrgChartViz.initTree({
        id: '#cascade-visualization',
        data,
        width: divWidth,
        height: containerHeight,
        rootParentId: this.props.metricId,
        currentUserId: this.props.currentUserId || '',
        pingPermission: this.props.pingPermission || false,
        expandFull: this.props.expandFull || false,
        cascade: this.props.cascade || false,
        openKRPage: this.props.openKRPage || null,
        metricType: this.props.metricType || null,
        setVizStyles: this.setVizStyles.bind(this)
      });
    });
  }

  componentWillUnmount() {
    this.setVizStyles(false);
  }

  clickBackLink() {
    this.setVizStyles(false);
    const metricWrapper = document.querySelector('.wb-ghead-metrics-wrapper');
    if (metricWrapper) {
      metricWrapper.style.display = 'block';
    }
    const viewCascadeTree = document.querySelector('.wb-ghead-metrics-wrapper-view-cascade-tree');
    if (viewCascadeTree) {
      viewCascadeTree.style.display = 'none';
    }
  }

  // Set styles for d3 trees
  setVizStyles(enable) {
    // Floating footer
    let elem = document.querySelector('div#footer');
    if (elem) {
      const isIE = navigator.userAgent.indexOf("MSIE ") > -1 || navigator.userAgent.indexOf("Trident/") > -1;
      if (isIE) {
        elem.style.display = enable ? 'none' : null;
      } else {
        if (enable) {
          elem.classList.add('fixedbottom-footer');
        } else {
          elem.classList.remove('fixedbottom-footer');
        }
      }
    }
  }

  render() {
    const { t } = this.props
    const containerStyle = {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      width: '100%',
      overflow: 'hidden',
      position: 'relative'
    };
    const visualizationStyle = {
      flex: 1,
      overflow: 'hidden',
      minHeight: 0,
      width: '100%'
    };
    return (
      <div className="view-cascade-visualization" style={containerStyle}>
        <div className="backlink" onClick={() => this.clickBackLink()}>
          <div className="icon icon-outline-arrow_back_ios-24px left" />
          <div className="back-btn left">
            {t('Back')}
          </div>
          <div className="clear" />
        </div>
        <div id="cascade-visualization" ref={this.containerRef} style={visualizationStyle}> </div>
      </div>
    );
  }
}

ViewCascadeVisualizationComp.defaultProps = {
  data: {},
  metricId: null,
  t: withTranslation()
};
